export default "__VITE_ASSET__$mLUksgj__"